import styles from './Button.module.scss';

import cx from 'classnames';
import React, { forwardRef } from 'react';

import { LinkVariant } from 'api/contentful/contentTypes.cloverdotcom';
import { stringFormatForTestAttr } from 'utils/StringFormatForTest';

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: LinkVariant;
  isFullWidth?: boolean;
  dataTestId?: string;
}

export const Button = forwardRef<HTMLButtonElement, IButtonProps>(
  ({ className, style, variant, isFullWidth, children, ...props }, ref) => {
    const buttonClassName = cx(
      {
        [styles.buttonVariantPrimary]: variant === LinkVariant.PRIMARY,
        [styles.buttonVariantSecondary]: variant === LinkVariant.SECONDARY,
        [styles.buttonVariantText]: variant === LinkVariant.TEXT,
        [styles.buttonFullWidth]: isFullWidth,
      },
      styles.button,
      className,
    );

    if (!children) return null;
    let dataTestId = '';
    if (props.dataTestId) {
      dataTestId = props.dataTestId;
    } else {
      dataTestId =
        props.id === undefined
          ? stringFormatForTestAttr(`${children.toString()}-button`)
          : stringFormatForTestAttr(`${props.id?.toString()}-button`);
    }

    return (
      <button className={buttonClassName} style={style} data-testid={dataTestId} ref={ref} {...props}>
        {children}
      </button>
    );
  },
);

Button.displayName = 'Button';
